/* global axios */
import ApiClient from './ApiClient';

class CompaniesAPI extends ApiClient {
  constructor() {
    super('companies', { accountScoped: true });
  }

  list({ page = 1, query = '', sort = '', labels = [] } = {}) {
    const params = { page };
    if (query) params.q = query;
    if (sort) params.sort = sort;
    if (labels.length) params.labels = labels;
    return axios.get(this.url, { params });
  }

  create(company) {
    return axios.post(this.url, { company });
  }

  update(id, company) {
    return axios.patch(`${this.url}/${id}`, { company });
  }
}

export default new CompaniesAPI();
